import _ from 'lodash';
import utils from 'lib/utils';
import config from 'config';

const { baseUrl } = config;

export const fetchAuditAgainstEntityId = async (params = {}) => {
  try {
    const url = `${baseUrl}/BioFuelCommonUtilities/api/Audit/FetchAuditAgainstEntityId`;
    const res = await utils.fetch(url, {
      method: 'POST',
      body: JSON.stringify(params),
    }).ready;
    const resData = await utils.processApiRes(res);
    return resData;
  } catch (err: any) {
    const errors = await utils.processApiErrors(err, '', 'FetchAuditAgainstEntityId');
    throw errors;
  }
};
